module.exports = __webpack_public_path__ + "img/icon3.3afaa8e9.png";